export const UGA_EXTERNAL_SOURCE_TYPE_ID = 8;

export const EXTERNAL_SOURCE_TYPES = [
  {
    label: "EG",
    value: 2,
  },
  {
    label: "USATP - Question",
    value: 1,
  },
  {
    label: "USATP - Drag Drop",
    value: 3,
  },
  {
    label: "USATP - Video",
    value: 4,
  },
  {
    label: "USATP - EBSR",
    value: 5,
  },
  {
    label: "HE",
    value: 6,
  },
  {
    label: "Lennections",
    value: 7,
  },
  {
    label: "UGA",
    value: UGA_EXTERNAL_SOURCE_TYPE_ID,
  },
  {
    label: "ACT",
    value: 9,
  },
];
